module.exports = "<input type=\"checkbox\"\n       [id]=\"id\"\n       [name]=\"name\"\n       [disabled]=\"disabled\"\n       [(ngModel)]=\"innerValue\">\n<label [for]=\"id\"><span></span></label>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-checkbox/ui-checkbox.html
// module id = 1092
// module chunks = 3